<template>
  <div class="card">
    <div class="card-body">
      <h2>About listwise</h2>
      <div class="about-item mb-5">
        <p>TV and Movie data is provided by <a href="https://www.themoviedb.org">The Movie Database</a></p>
        <p><a href="https://www.themoviedb.org"><img src="https://www.themoviedb.org/assets/2/v4/logos/408x161-powered-by-rectangle-green-bb4301c10ddc749b4e79463811a68afebeae66ef43d17bcfd8ff0e60ded7ce99.png" alt=""></a></p>
        <small class="text-body">This product uses the TMDb API but is not endorsed or certified by TMDb.</small>
      </div>
      <div class="about-item mb-5">
        <p>Video Game data is provided by <a href="https://www.igdb.com/">IGDB</a></p>
        <p><a href="https://www.igdb.com/"><img src="https://www.igdb.com/apple-icon-144x144.png" alt=""></a></p>
      </div>
      <div class="about-item mb-5">
        <p>Book data is provided by <a href="https://books.google.com">Google Books</a></p>
        <p><a href="https://books.google.com"><img src="../assets/img/Google_Books_logo.png" alt=""></a></p>
      </div>
      <div class="about-item mb-5">
        <p>Board Game data is provided by <a href="https://www.boardgameatlas.com">Board Game Atlas</a></p>
        <p><a href="https://www.boardgameatlas.com"><img src="../assets/img/boardgameatlaslogo.png" alt=""></a></p>
      </div>
      <p><i class="fa" :class="{'fa-check': isTouch, 'fa-times': !isTouch}"></i></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  computed: {
    isTouch(){
      return this.$store.state.isTouch
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  height: 55px;
}
</style>
